import { Container, Box, Typography } from "@mui/material";
import ResetPasswordForm from "./ResetPasswordForm";

const ResetPassword: React.FC = () => {
    return (
        <Box
            sx={{
                minHeight: "70vh",          // ✅ όπως ζήτησες
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                pt: 6,                      // απόσταση από header
                backgroundColor: "#f5f7fa", // soft γκρι φόντο (optional)
            }}
        >
            <Container maxWidth="sm">
                {/* ✅ Τίτλος */}
                <Typography
                    sx={{
                        fontSize: 24,
                        fontWeight: 600,
                        mb: 3,
                        textAlign: "center",
                        color: "#1a1a1a",
                    }}
                >
                    Επαναφορά Κωδικού
                </Typography>

                {/* ✅ Κάρτα Περιεχομένου */}
                <Box
                    sx={{
                        backgroundColor: "#ffffff",
                        borderRadius: "12px",
                        p: 3,
                        boxShadow: "0px 8px 24px rgba(0,0,0,0.08)",
                    }}
                >
                    <ResetPasswordForm />
                </Box>
            </Container>
        </Box>
    );
};

export default ResetPassword;
